// Search
const tools = document.querySelector('.tools');
let searchTool = tools.querySelector('.tools__search');
let searchPopup = document.querySelector('.search-popup');

searchTool.addEventListener('click', function(){
    document.body.classList.add('search-open');
    searchPopup.classList.remove('hideX');
    searchPopup.classList.add('showX');
    document.querySelector('.searchInput').focus()
})

if (searchPopup) {
    let searchClose = searchPopup.querySelector('.search-close');

    if (searchClose) {
        searchClose.addEventListener('click', function () {
            document.body.classList.remove('search-open');
            searchPopup.classList.add('hideX');
            searchPopup.classList.remove('showX');
        })
    }
}


// Function eventFire
function eventFire(el, etype){
    if (el.fireEvent) {
        el.fireEvent('on' + etype);
    } else {
        let evObj = document.createEvent('Events');
        evObj.initEvent(etype, true, false);
        el.dispatchEvent(evObj);
    }
}
